import React from 'react';

import DynStyles from './DynStyles';
import CSSRules from './CSSRules';

class DynamicStylesTag extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // Colors
      colors: props.colors,
      accent: props.accent,
      dark: props.dark,
      light: props.light,
      contrast: props.contrast,
      // Avatar
      avatar_scale: props.avatar_scale,
      avatar_url: props.avatar_url,
      // Fonts
      font: props.font,
      font_size: props.font_size,
      // Content variables
      logo: props.logo,
      // Background variables
      background_image_url: props.background_image_url,
      background_color: props.background_color,
      gradient_from: props.gradient_from,
      gradient_to: props.gradient_to,
      // Filter variables
      filter_color: props.filter_color,
      filter_gradient_from: props.filter_gradient_from,
      filter_gradient_to: props.filter_gradient_to,
      filter_image_url: props.filter_image_url,
      // External
      stylesheets: props.stylesheets,
      // Custom
      style: props.style,
    };
    this.dynStyles = new DynStyles('custom-styles');
    this.ee = props.ee;
  }

  componentDidMount() {
    this.stablishRules();
    this.ee.emit('hu-lb-rendered');
  }

  stablishRules() {
    this.dynStyles.setupStylesheet();
  }

  componentWillReceiveProps(nextProps) {
    // Sólo son re-renderizadas aquellas reglas que son diferentes a un estado anterior.
    const diffProps = Object.keys(this.props).filter((a) => this.props[a] !== nextProps[a]);
    for (let i = 0; i < diffProps.length; i++) {
      switch (diffProps[i]) {
        case 'avatar_scale':
          this.dynStyles.setVariable('avatar_scale', `scale(${nextProps.avatar_scale})`);
          break;
        case 'font':
          this.dynStyles.setVariable('font', `${nextProps.font},sans-serif`);
          break;
        case 'font_size':
          this.dynStyles.setVariable('font_size', `${nextProps.font_size}px`);
          break;
        case 'gradient_to':
        case 'gradient_from':
          this.dynStyles.setVariable('background_gradient', `linear-gradient(to bottom, ${nextProps.gradient_from} 0%, ${nextProps.gradient_to} 100%)`);  
          break;
        case 'filter_gradient_to':
        case 'filter_gradient_from':
          this.dynStyles.setVariable('background_gradient', `linear-gradient(to bottom, ${nextProps.gradient_from} 0%, ${nextProps.gradient_to} 100%)`);
          break;
        case 'avatar_url':
          this.dynStyles.setVariable('avatar_url', `url("${nextProps.avatar_url}")`);
          break;
        case 'logo':
        //   this.dynStyles.setVariable('logo', `url("${nextProps.logo}")`);
          break;
        case 'background_image_url':
          this.dynStyles.setVariable('background_image_url', `url("${nextProps.background_image_url}")`);
          break;
        case 'filter_image_url':
          this.dynStyles.setVariable('filter_image_url', `url("${nextProps.filter_image_url}")`);
          break;
        case 'videoname':
          this.dynStyles.setVariable('background_video_fallback', `url("https://storage.googleapis.com/static.helloumi.com/landbot/video/${videoname}.jpg")`);
          break;
        // Excluding cases. Don't use dynStyles with this params.
        case 'colors':
        case 'stylesheets':
        case 'style':
          break;
        // By default
        default:
          this.dynStyles.setVariable(diffProps[i], nextProps[diffProps[i]]);
          break;
      }
    }
    // Complex properties
    const { colors } = this.props;
    if (JSON.stringify(colors) !== JSON.stringify(nextProps.colors)) {
      for (let _var in colors) {
        if (nextProps.colors[_var]) {
          this.dynStyles.setVariable(_var, nextProps.colors[_var]);
        }
      }
    }
  }

  cleanFont(font) {
    const FONTS = [
      'Droid Serif',
      'Inconsolata',
      'Montserrat',
      'Open Sans',
      'Oswald',
      'Raleway',
      'Roboto',
      'Roboto slab',
      'Lato',
    ];
    // return (FONTS.indexOf(font) > -1) ? font : 'Montserrat';
    return font;
  }

  getLink(link) {
    return (
      <link href={link} rel="stylesheet" />
    );
  }

  render() {
    const { font, stylesheets, style } = this.props;
    let _font = this.cleanFont(font);
    const fontUrl = `https://fonts.googleapis.com/css?family=${_font}:400,400i,700,700i`;

    return (
      <div id="styles">
        <style>{style}</style>
        <link href={fontUrl} rel="stylesheet" />
        <style id={this.dynStyles.getID()}></style>
        {stylesheets.map(this.getLink)}
      </div>
    );
  }
}

export default DynamicStylesTag;


// WEBPACK FOOTER //
// ./app/js/components/dynamic-styles/DynamicStylesTag.js